import api from '../../services/api';
import {
  AI_WORKSHEET_REVIEW,
  AI_WORKSHEET_REVIEW_CONFIG,
  AI_WORKSHEET_REVIEW_LATEST,
} from '../../config/Config';

export function getAiWorksheetReviewConfig() {
  return api.get(AI_WORKSHEET_REVIEW_CONFIG);
}

export function requestAiWorksheetReview(worksheetId, uploadSource = 'student') {
  return api.post(AI_WORKSHEET_REVIEW(worksheetId), { upload_source: uploadSource });
}

export function getLatestAiWorksheetReview(worksheetId, uploadSource = 'student') {
  return api.get(AI_WORKSHEET_REVIEW_LATEST(worksheetId), {
    params: { upload_source: uploadSource },
  });
}

